import React from 'react';
import { TextFieldHintText, FieldsetHintText } from './styles';
import sanitizeHtml from '~/utils/sanitize-html';

interface HintTextProps {
    fieldsetHintText?: boolean;
    id: string | undefined;
    readonly?: boolean;
    children: string;
    className?: string;
}

const HintText = ({
    fieldsetHintText = false,
    id,
    readonly = false,
    children,
    className,
}: HintTextProps) => {
    return fieldsetHintText ? (
        <FieldsetHintText
            id={id}
            className={className}
            readOnly={readonly}
            tabIndex={-1}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(children, { FORCE_BODY: true }) }}
        />
    ) : (
        <TextFieldHintText
            id={id}
            className={className}
            readOnly={readonly}
            tabIndex={-1}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(children, { FORCE_BODY: true }) }}
        />
    );
};

export default HintText;
